import { resourceQueryParamName } from 'constants/resourceQueryNames';
import { useNavParamsByResource } from 'hooks/nav/useNavParamsByResource';
import { RequestParamsType, RequestResponse } from 'hooks/types/client';
import type { RouteParams } from 'types';
import useRequest from '../client/useRequest';

type Options = {
  redirectOnError?: boolean;
  enabled?: boolean;
  queryParamsOverride?: RouteParams;
};

type UseInvestigations = (options?: Options) => RequestResponse<'investigations.list'>;

const useInvestigations: UseInvestigations = (options) => {
  const resourceParams = useNavParamsByResource(resourceQueryParamName.investigations);

  const params: RequestParamsType = {
    queryParams: {
      ...resourceParams,
      ...(options?.queryParamsOverride ?? {}),
      include_count: true,
    },
    redirectOnError: options?.redirectOnError,
  };

  return useRequest('investigations.list', params, {
    enabled: options?.enabled ?? true,
  });
};

export default useInvestigations;
